import { gdprService } from '../api'

const OBJECT_URL_REVOKE_DELAY_MS = 40_000

type TriggerBrowserDownloadOptions = {
  blob: Blob
  filename: string
}

export const triggerBrowserDownload = ({ blob, filename }: TriggerBrowserDownloadOptions): void => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.setTimeout(() => window.URL.revokeObjectURL(url), OBJECT_URL_REVOKE_DELAY_MS)
}

export async function downloadUserDataExport(userId: string): Promise<void> {
  const { blob, filename } = await gdprService.exportUserData(userId)
  triggerBrowserDownload({ blob, filename })
}
